import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles';
import AdditionalInformationsForm from './AdditionalInformationsForm';
const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.object.isRequired,
  enableEditing: PropTypes.bool.isRequired,
  setBuilder: PropTypes.func.isRequired,
};

export const AdditionalInformations = props => {
  const { classes, userAttributes, enableEditing, setBuilder } = props;
  const initialValues = {
    'custom:newBuildsPerYear': userAttributes['custom:newBuildsPerYear'],
    'custom:businessYears': userAttributes['custom:businessYears'],
    'custom:employeesCount': userAttributes['custom:employeesCount'],
    'custom:renovationsPerYear': userAttributes['custom:renovationsPerYear'],
  };

  console.log('🚀 ~ file: index.js ~ line 61 ~ initialValues', initialValues);
  return (
    <Card className={classes.cardRoot}>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Additional Info"
      />
      <CardContent
        classes={{
          root: classes.cardContentRoot,
        }}
      >
        <AdditionalInformationsForm
          initialValues={initialValues}
          enableReinitialize
          userAttributes={userAttributes}
          enableEditing={enableEditing}
          setBuilder={setBuilder}
        />
      </CardContent>
    </Card>
  );
};

AdditionalInformations.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({});

export default withStyles(styles)(
  connect(mapStateToProps)(AdditionalInformations),
);
